// src/Pages/AboutPage.js
import React from 'react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-2xl p-8 md:p-12 border border-gray-100">
        <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-10 drop-shadow-sm">About Celerity Technocrats</h2>
        <div className="flex flex-col md:flex-row items-center md:space-x-10">
          <div className="md:w-1/2 mb-8 md:mb-0">
            <img
              src="https://placehold.co/600x400/A78BFA/FFFFFF?text=Global+Team+Collaboration"
              alt="Global Team Collaboration"
              className="rounded-lg shadow-xl w-full h-auto object-cover transform transition-transform duration-300 hover:scale-[1.02] border border-purple-100"
              onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/A78BFA/FFFFFF?text=Image+Unavailable'; }}
            />
          </div>
          <div className="md:w-1/2">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Celerity Technocrats is a leading software development company dedicated to delivering innovative and high-quality IT solutions globally. Our strength lies in our diverse and highly skilled team, strategically located across key regions to ensure seamless collaboration and round-the-clock support.
            </p>
            <h3 className="text-2xl font-bold text-blue-700 mb-4">Our Global Presence & Expertise:</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
              <li>
                <span className="font-semibold">Distributed Team:</span> Our talented professionals are based in the <span className="font-bold text-black-600">USA</span>, <span className="font-bold text-black-600">UK</span>, <span className="font-bold text-black-600">Canada</span>, and <span className="font-bold text-black-600">India</span>, bringing a rich blend of perspectives and expertise to every project.
              </li>
              <li>
                <span className="font-semibold">Technical Excellence:</span> We pride ourselves on our deep technical knowledge and commitment to best practices, ensuring robust and future-proof solutions.
              </li>
              <li>
                <span className="font-semibold">Global Customer Base:</span> We have successfully served clients from diverse industries in the <span className="font-bold text-black-600">USA</span>, <span className="font-bold text-black-600">Canada</span>, the <span className="font-bold text-black-600">UK</span>, <span className="font-bold text-black-600">Australia</span>, <span className="font-bold text-black-600">Georgia</span>, <span className="font-bold text-black-600">Qatar</span>, and <span className="font-bold text-black-600">India</span>.
              </li>
              <li>
                <span className="font-semibold">Unwavering Commitment:</span> Our 99.99% on-time delivery ratio is a testament to our dedication and efficiency.
              </li>
            </ul>
            <p className="text-lg text-gray-700 leading-relaxed">
              We believe in building long-term partnerships by consistently exceeding expectations and providing unparalleled value.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;

// import { About } from "../components/About";

// // pages/About.js
// const AboutPage = () => (
//   <div className="container-fluid">
//     <About />
//   </div>
// );

// export default AboutPage;
